import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

Object.assign(cardContainerStyles, {
    ...cardContainerStyles,
    cardDivider: {
        css: css`
            width: calc(100% - 20px);
            margin: 0;
            border-bottom: 0;
        `,
    },
});
